import React from 'react';
import { reduxForm, Field, isDirty, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import * as actDiscount from 'actions/library/discount';
import { askConfirmAction } from 'actions/confirm-action';
import * as clevertapLibraryDiscount from 'clevertap/library/discount';
import MenuTitle from 'components/MenuTitle';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { outlets } = this.props;
    return (
      <div>
        <MenuTitle menuTitle="Discounts" />
        <div className="col-sm-8 hidden-xs col-md-6 action-discounts">
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this._onClickCreateDiscount}
            >
              Create Discount
            </button>
          </span>
        </div>
        <div className={styles.wrapper}>
          <div className="row">
            <div className="col-sm-4 col-xs-12 outlet-discounts">
              <Field
                name="outletIds"
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutletIds}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickCreateDiscount = () => {
    const { isDirtyDiscount } = this.props;
    if (isDirtyDiscount) {
      this.props.dispatch(
        askConfirmAction(actDiscount.onClickCreateDiscount())
      );
    } else {
      this.props.dispatch(actDiscount.onClickCreateDiscount());
    }
  };

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIdsAsObject
   */
  _onChangeOutletIds = outletIds => {
    const { isDirtyDiscount, searchvalues } = this.props;
    const prevOutlet = searchvalues.outletIds[0];
    clevertapLibraryDiscount.libraryDiscountChangeOutlet({
      prevOutlet,
      currOutlet: outletIds,
    });
    if (isDirtyDiscount) {
      this.props.dispatch(
        askConfirmAction(actDiscount.onChangeOutletIds(outletIds))
      );
    } else {
      this.props.dispatch(actDiscount.onChangeOutletIds(outletIds));
    }
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const { outlets } = state.library.discount;
  const isDirtyDiscount = isDirty('discount')(state);
  return {
    isDirtyDiscount,
    outlets,
    searchvalues: getFormValues('search')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
